import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingConfigurationPriceImportActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/PriceImport/PriceImportForm")
	}

	render() {
		return (
			<Activity 
				name="AccountingConfigurationPriceImport"
				RenderedComponent={this.RenderedComponent}
				context="AccountingConfigurationPriceImport"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingConfigurationPriceImportActivity)
